function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["className"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import { BrandfolderHexColors } from "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyBook, fontFamilyMedium } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import { BaseTabs } from "../base-tabs/base-tabs.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardTabs = function BaseStandardTabs(props) {
  var className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseTabs, _extends({}, otherProps, {
    className: classnames(_defineProperty({
      'bf-tabs__standard': true
    }, "".concat(className), !!className))
  }));
};
var Tabs = styled(BaseStandardTabs)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n\n  .bf-tabs__tab {\n    background-color: transparent;\n    border: 0;\n    border-bottom: 2px solid ", ";\n    border-radius: 0;\n    color: ", ";\n    cursor: pointer;\n    display: block;\n    flex: 1;\n    font-family: ", ";\n    font-size: 14px;\n    line-height: 22px;\n    padding: 10px 5px;\n    transition:\n      border 0.2s ease,\n      border-color 0.2s ease,\n      color 0.2s ease;\n    width: 100%;\n    z-index: 1;\n\n    &[aria-selected='true'] {\n      border-bottom-color: ", ";\n      color: ", ";\n      cursor: default;\n      font-family: ", ";\n    }\n\n    &[aria-disabled='true'] {\n      border-bottom-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n\n    &:focus:not([aria-disabled='true']):not([aria-selected='true']),\n    &:hover:not([aria-disabled='true']):not([aria-selected='true']) {\n      border-bottom-color: ", ";\n      color: ", ";\n    }\n  }\n\n  .bf-tabs__tablist {\n    display: flex;\n    min-width: 250px;\n    position: relative;\n  }\n\n  .bf-tabs__tabpanel {\n    margin-top: 15px;\n    min-width: 250px;\n    padding: 15px;\n    position: relative;\n\n    &[hidden] {\n      display: none;\n    }\n\n    @media (min-width: 767px) {\n      margin-top: 30px;\n    }\n  }\n\n  .bf-tabs__slider {\n    background-color: ", ";\n    bottom: 0;\n    display: block;\n    height: 2px;\n    left: 0;\n    position: absolute;\n    transition: left 0.2s ease;\n    width: 100%;\n  }\n\n  .bf-tabs__underline {\n    background-color: ", ";\n    bottom: 0;\n    display: block;\n    height: 2px;\n    left: 0;\n    position: absolute;\n    width: 100%;\n  }\n"])), fontFamilyBook, BrandfolderHexColors.GrayBorder, BrandfolderHexColors.GrayDark, fontFamilyBook, BrandfolderHexColors.Text, BrandfolderHexColors.Text, fontFamilyMedium, BrandfolderHexColors.GrayBorder, BrandfolderHexColors.Gray, BrandfolderHexColors.PurplePopsicle, BrandfolderHexColors.PurplePopsicle, BrandfolderHexColors.GrayDark, BrandfolderHexColors.GrayBorder);
/**
 * Tabs widget that displays a `tablist`, `tab`, and `tabpanel` elements.
 * `caption`, `id`, and an array of `tabs` are all required props.
 *
 * Construct your tabs by using `StandardTab[]` to create an array that is passed
 * in to the `tabs` prop. Each tab should have a `tabButton` and `tabPanel` attribute.
 *
 * By default, the first tab will be activated on render. To specify a different tab
 * that should be active, use the `initialActiveIndex` prop. To programmatically change
 * to a tab after render, use the `changeToIndex` prop.
 *
 * There are two types of tabs:
 * [Manual activation](https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-manual.html) and
 * [automatic activation](https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html).
 * By default, `activatePanelOnPrevNext` is `true` for automatic activation.
 *
 * More about tabs from W3C: https://www.w3.org/WAI/ARIA/apg/patterns/tabpanel/.
 *
 * @param props StandardTabsProps
 * @returns FunctionComponent<StandardTabsProps>
 */
var StandardTabs = function StandardTabs(props) {
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Tabs, _extends({}, props)));
};
export { BaseStandardTabs, StandardTabs };